var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3040_8167)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 57,
    width: 349,
    height: 455,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.004 0H68.9955C30.8924 0 0.00244141 30.8887 0.00244141 68.993V443.004C0.00244141 481.109 30.8912 511.998 68.9955 511.998H253.455L253.769 329.037H206.236C200.059 329.037 195.045 324.042 195.022 317.865L194.794 258.889C194.77 252.678 199.799 247.631 206.01 247.631H253.456V190.645C253.456 124.514 293.845 88.5055 352.838 88.5055H401.247C407.44 88.5055 412.463 93.5267 412.463 99.7215V149.45C412.463 155.642 407.444 160.662 401.253 160.666L371.545 160.68C339.463 160.68 333.251 175.925 333.251 198.298V247.632H403.747C410.464 247.632 415.675 253.498 414.884 260.168L407.894 319.144C407.225 324.788 402.439 329.04 396.756 329.04H333.565L333.251 512H443.007C481.11 512 511.999 481.111 511.999 443.008V68.993C511.997 30.8887 481.109 0 443.004 0Z",
    fill: "#475993"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3040_8167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e2ee2eb04348df0c0cb5e160288cb21a.svg";
export { ForwardRef as ReactComponent };